import { useCallback } from 'react';
import type { UnsharpMaskValue } from '../../lib/filters/unsharp-mask';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Unsharp Mask panel — three sliders matching the Photoshop control
 *  surface: amount, radius, threshold. Defaults to amount=0 so the
 *  initial open is identity. */
export function UnsharpMaskPanel({ value, onChange }: AdjustmentPanelProps<UnsharpMaskValue>) {
  const set = useCallback(
    (patch: Partial<UnsharpMaskValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Amount"
        min={0}
        max={500}
        step={1}
        value={value.amount}
        onChange={(v) => set({ amount: v })}
      />
      <RangeRow
        label="Radius"
        min={0}
        max={50}
        step={1}
        value={value.radius}
        onChange={(v) => set({ radius: v })}
      />
      <RangeRow
        label="Threshold"
        min={0}
        max={255}
        step={1}
        value={value.threshold}
        onChange={(v) => set({ threshold: v })}
      />
    </div>
  );
}
